import BaseModel from "../base/baseModel";
import ClasseTerapeutica from "../enum/classeTerapeutica";

export default class ListaControladoModel extends BaseModel {
    id?: number = null;
    franquiaId?: number = null;
    descricao: string = null;
    codigo: string = null;
    classeTerapeutica?: ClasseTerapeutica = null;
}